export { default as StrategyDropdown } from './StrategyDropdown';
